// import React, { useState } from 'react';
// import classNames from 'classnames';
// import { Link } from 'react-router-dom';
// import { Menu, X } from 'react-feather';
// import { MdOutlineCategory } from "react-icons/md";
// import { MdProductionQuantityLimits } from "react-icons/md";
// import { FiLogOut } from "react-icons/fi";
// import { FaBorderAll } from "react-icons/fa6";
// import { GiKnightBanner } from "react-icons/gi";
// import { RiCoupon3Line } from "react-icons/ri";
// import { RxDashboard } from "react-icons/rx";

// const linkClass =
//     'font-medium px-1 py-2 hover:bg-blue-500 hover:no-underline flex gap-2  items-center active:bg-blue-500 rounded-sm text-white';

// const collapsedLinkClass =
//     'font-medium p-2  py-2 hover:bg-blue-500 hover:no-underline active:bg-blue-500 rounded-sm text-xl text-white';

// export default function Sidebar() {
//     const [isCollapsed, setIsCollapsed] = useState(false);

//     return (
//         <div
//             className={classNames('bg-slate-900 p-3 flex flex-col relative', {
//                 'w-60': !isCollapsed,
//                 'w-20': isCollapsed,
//             })}
//         >
//             <div className="flex items-center px-1 py-3">
//                 {!isCollapsed && (
//                     <span className="text-neutral-200 font-bold text-lg">VersAttires</span>
//                 )}
//                 <button className="ml-auto" onClick={() => setIsCollapsed(!isCollapsed)}>
//                     {isCollapsed ? <Menu className="w-6 h-6 text-neutral-100" /> : <X className="w-6 h-6 text-neutral-100" />}
//                 </button>
//             </div>
//             <div
//                 className={classNames('flex flex-1 flex-col  gap-0.5 py-8 overflow-y-auto', {
//                     'h-48': isCollapsed,
//                 })}
//             >
//                 <Link to="/dashboard" className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <RxDashboard className='text-xl'/>
//                     {!isCollapsed && 'Dashboard'}
//                 </Link>

                

//                 <Link to="/dashboard/category" class className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <MdOutlineCategory className='text-xl' />
//                 {!isCollapsed && 'Categories'}
//                 </Link>

                

                
//                 <Link to="/dashboard/Banner" class className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <GiKnightBanner className='text-xl' />
//                 {!isCollapsed && 'Banners'}
//                 </Link>


//                 <Link to="/dashboard/product" class className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <MdProductionQuantityLimits className='text-xl' />
//                 {!isCollapsed && 'Products'}
//                 </Link>
                
//                 <Link to="/dashboard/coupon" class className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <RiCoupon3Line className='text-xl' />
//                 {!isCollapsed && 'Coupons'}
//                 </Link>
                
                

//                 <Link to="/dashboard/order" class className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <FaBorderAll  className='text-xl'/>
//                 {!isCollapsed && 'Order'}
//                 </Link>


                
//                 <Link to="/logout" class className={!isCollapsed ? linkClass : collapsedLinkClass}>
//                 <FiLogOut  className='text-xl'/>
//                 {!isCollapsed && 'Logout'}
//                 </Link>
//             </div>
           
//         </div>
//     );
// }




import React, { useState } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'react-feather';
import { MdOutlineCategory } from "react-icons/md";
import { MdProductionQuantityLimits } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { FaBorderAll } from "react-icons/fa6";
import { GiKnightBanner } from "react-icons/gi";
import { RiCoupon3Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";

const linkClass = (isActive, isCollapsed) => 
    classNames(
        'flex items-center gap-3 font-medium py-2.5 hover:bg-blue-600/30 active:bg-blue-700/40 rounded-md text-white transition-all duration-300 ease-in-out overflow-hidden',
        {
            'px-3': !isCollapsed,
            'px-2.5 justify-center': isCollapsed,
            'bg-blue-600/20 border-l-4 border-blue-400': isActive,
            'hover:border-l-4 hover:border-blue-400/50': !isActive,
        }
    );

const iconClass = (isActive) => 
    classNames('text-xl transition-colors duration-300', {
        'text-blue-400': isActive,
        'text-neutral-300 hover:text-blue-400': !isActive,
    });

export default function Sidebar() {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div
            className={classNames(
                'bg-slate-900 p-4 flex flex-col relative transition-all duration-300 ease-in-out shadow-xl',
                {
                    'w-64': !isCollapsed,
                    'w-20': isCollapsed,
                }
            )}
        >
            <div className="flex items-center px-2 py-4">
                {!isCollapsed && (
                    <span className="text-neutral-200 font-bold text-xl tracking-wide">
                        Rekha collection
                    </span>
                )}
                <button 
                    className="ml-auto p-1.5 hover:bg-slate-800 rounded-lg transition-colors duration-300"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                >
                    {isCollapsed ? (
                        <Menu className="w-6 h-6 text-neutral-100 hover:text-blue-400" />
                    ) : (
                        <X className="w-6 h-6 text-neutral-100 hover:text-blue-400" />
                    )}
                </button>
            </div>
            
            <nav className="flex flex-1 flex-col gap-1.5 py-8 overflow-y-auto">
                <NavLink 
                    to="/dashboard" 
                    end // Add the `end` prop to ensure it only matches exactly `/dashboard`
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <RxDashboard className={iconClass(isActive)} />
                            {!isCollapsed && 'Dashboard'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/category" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <MdOutlineCategory className={iconClass(isActive)} />
                            {!isCollapsed && 'Categories'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/Banner" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <GiKnightBanner className={iconClass(isActive)} />
                            {!isCollapsed && 'Banners'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/product" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <MdProductionQuantityLimits className={iconClass(isActive)} />
                            {!isCollapsed && 'Products'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/coupon" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <RiCoupon3Line className={iconClass(isActive)} />
                            {!isCollapsed && 'Coupons'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/dashboard/order" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <FaBorderAll className={iconClass(isActive)} />
                            {!isCollapsed && 'Order'}
                        </>
                    )}
                </NavLink>

                <NavLink 
                    to="/logout" 
                    className={({ isActive }) => linkClass(isActive, isCollapsed)}
                >
                    {({ isActive }) => (
                        <>
                            <FiLogOut className={iconClass(isActive)} />
                            {!isCollapsed && 'Logout'}
                        </>
                    )}
                </NavLink>
            </nav>
        </div>
    );
}